import { Link } from "react-router-dom";
import { SEMANTICS } from "@/constants/testIds";

export function SemanticsTabs({ active }) {
  const base = "rounded-full px-3 py-1 text-[11px] uppercase tracking-[0.14em] transition-colors";
  const on = "bg-accent/15 text-accent";
  const off = "text-muted-foreground hover:text-foreground";
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-border/60 bg-card/40 p-1">
      <Link data-testid={SEMANTICS.graphTab} to="/semantics" className={`${base} ${active === "graph" ? on : off}`}>Graph</Link>
      <Link data-testid={SEMANTICS.metricsTab} to="/semantics/metrics" className={`${base} ${active === "metrics" ? on : off}`}>Metrics</Link>
      <Link data-testid={SEMANTICS.packsTab} to="/semantics/packs" className={`${base} ${active === "packs" ? on : off}`}>Packs</Link>
    </div>
  );
}
